export default "__VITE_ASSET__cd332814__"